import Controller from "./captainInvoices.controller";
import template from "./captainInvoices.html";

const captainInvoices = {
  template,
  controller: Controller,
};

export default captainInvoices;



// WEBPACK FOOTER //
// ./src/pages/captainInvoices/captainInvoices.component.js